// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { WorkFieldUserChangeEvent } from '../../events/work-field-user-change-event';
import { E5coreUiWorkFieldTypeBase } from '../../components/e5core-ui-work-field/e5core-ui-work-field-type-base';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-user',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-user-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' ></e5core-ui-work-field-type-user-box>
    <e5core-ui-work-field-type-user-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' ></e5core-ui-work-field-type-user-bootstrap>
    <e5core-ui-work-field-type-user-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' ></e5core-ui-work-field-type-user-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeUserComponent extends E5coreUiWorkFieldTypeBase {

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldUserChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, $event.value, $event.error) ;
  }

}
